import userImg from "../assets/images/userImg1.jpeg";

export const reviewsData = [
  {
    id: 34239,
    name: "Person Humanaliev",
    image: userImg,
    comment: "This is the best school in our country",
  },
  {
    id: 42442,
    name: "Person Humanaliev",
    image: userImg,
    comment: "This is the best school in our country",
  },
  {
    id: 42344,
    name: "Person Humanaliev",
    image: userImg,
    comment: "This is the best school in our country",
  },
];
